import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import data from '../data/products.json';
import './../components/universal.css';
import './Products.css';

function flattenProducts(){
  const out = [];
  for (const c of data.categories || []) {
    // Some categories have products directly under them (no subcategories)
    if (Array.isArray(c.products)) {
      for (const p of c.products) {
        out.push({ ...p, categoryId: c.id, categoryName: c.name, subId: null, subName: null });
      }
    }

    if (!Array.isArray(c.subcategories)) continue;
    for (const s of c.subcategories) {
      if (!Array.isArray(s.products)) continue;
      for (const p of s.products) {
        out.push({ ...p, categoryId: c.id, categoryName: c.name, subId: s.id, subName: s.name });
      }
    }
  }
  return out;
}

export default function SearchResults(){
  const [searchParams] = useSearchParams();
  const q = (searchParams.get('q') || '').trim();

  const all = useMemo(flattenProducts, []);
  const results = useMemo(() => {
    if(!q) return [];
    const lower = q.toLowerCase();
    return all.filter(p => (p.name+ ' ' + (p.description||'') + ' ' + p.categoryName + ' ' + p.subName).toLowerCase().includes(lower));
  }, [all, q]);

  return (
    <main className="products-page container">
      <h2>Search results for "{q}"</h2>
      {q === '' && <p>Enter a search term in the top bar to find products.</p>}
      <div className="cards-grid" style={{marginTop:12}}>
        {results.map(p => (
          <div key={p.id} className="card product-card" >
            {p.image && <img src={p.image} alt={p.name} />}
            <div className="card-body">
              <h4>{p.name}</h4>
            
              <div style={{marginTop:28}}>
                <Link className='uni-btn' to={`/product/${p.id}`}>View details</Link><br></br><br></br>
                <span style={{marginLeft:12,color:'var(--color-accent)'}}> {p.categoryName} / {p.subName}</span>
              </div>
            </div>
          </div>
        ))}
        {q && results.length===0 && <div>No products found for "{q}"</div>}
      </div>
    </main>
  );
}
